import { gql } from '@apollo/client';

export const DELETE_EXTERNAL_POST_MUTATION = gql`
  mutation DeleteExternalPost($id: ID!) {
    deleteExternalPost(input: { where: { id: $id } }) {
      externalPost {
        id
      }
    }
  }
`;
